import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetConfigSeparacaoResponse } from '../../responses/vendas/get-config-separacao.response';
import { ConfigSeparacaoLookupsResponse } from '../../responses/vendas/config-separacao-lookups.response';
import { ConfigSeparacaoRequest } from '../../requests/vendas/config-separacao.request';

@Injectable({
    providedIn: 'root',
})
export class ConfigSeparacaoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'ConfigSeparacao';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<GetConfigSeparacaoResponse> {
        return this.httpClient
            .get<GetConfigSeparacaoResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookups(): Observable<ConfigSeparacaoLookupsResponse> {
        return this.httpClient
            .get<ConfigSeparacaoLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: ConfigSeparacaoRequest): Observable<GetConfigSeparacaoResponse> {
        const url = `${this.apiUrl}/idConfigSeparacao/${id}`;
        return this.httpClient
            .put<GetConfigSeparacaoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
